export default __webpack_public_path__ + "static/media/pemex-logo.453329ed.png";